import React, { useEffect, useRef, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import * as opdCentersCrud from '../../../configurations/crud/opdCentersCrud'
import { useToast } from '../../controls/Toast/ToastService'
import { MdErrorOutline } from 'react-icons/md'
import { Link, useParams } from 'react-router-dom'
import { LIVE_URL, PAGE_SIZE } from '../../../configurations/initUrls'
import moment from 'moment'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import { GetById } from '../../../configurations/crud/opdCentersCrud'
import { GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus'
import { FaCircleInfo } from "react-icons/fa6";
import { IoMdAdd } from "react-icons/io";
import AddOpdOffline from './AddOpdOffline'
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5'
import ReceptionConfirmed from './ReceptionConfirmed'
import ReceptionEmergency from './ReceptionEmergency'
import ReceptionRegistered from './ReceptionRegistered'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import WarningPopUp from './WarningPopUp'
import { VscDebugDisconnect } from 'react-icons/vsc'
import LoadingContainer from '../../controls/LoadingContainer'
import StatusContainer from '../../controls/StatusContainer'
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType'
import { allowSleep, keepAwake } from '../../../configurations/native/screenTime'
import { useKeepAwake } from 'react-keep-awake';
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { PiPlugsConnectedFill } from "react-icons/pi";

export default function Reception({ }) {
  const { start, end } = useGlobalLoader()
  const { centerid } = useParams()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [isOpenPop, setIsOpenPop] = useState(false)
  const [isOpenUnavailable, setIsOpenUnavailable] = useState(false)
  const [isOpenAbsent, setIsOpenAbsent] = useState(false)
  const [currentSavedData, setCurrentSavedData] = useState()
  const [serachPatient, setSerachPatient] = useState("")
  const [isSerachPatient, setIsSerachPatient] = useState(0)

  const [eventMessage, setEventMessages] = useState("");

  const [centerData, setCenterData] = useState();
  const [doctorStatus, setDoctorStatus] = useState(1);

  const [currentData, setCurrentData] = useState();
  const [nextPatientData, setNextPatientData] = useState();

  const [viewUsers, setViewUsers] = useState(1);
  const [isPrint, setIsPrint] = useState(false);

  const loginInfo = getLoginInfo()

  const audioRef = useRef(null);
  const audioEmergencyRef = useRef(null);
  useKeepAwake()
  useEffect(() => {
    keepAwake()
    return () => {
      allowSleep()
    }
  }, [])


  const ringBell = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((err) => {
        console.error("Playback failed:", err);
      });
    }
  };
  const ringBellEmergency = () => {
    if (audioEmergencyRef.current) {
      audioEmergencyRef.current.play().catch((err) => {
        console.error("Playback failed:", err);
      });
      toast.open(
        <div>
          <div className='font-bold'>Doctor's Call</div>
          <span>Please sent EMERGENCY numbers In.</span>
        </div>
        , <MdErrorOutline />, "danger", 10000);
    }
  };
  ///Chat Start Block\
  const [connection, setConnection] = useState();
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const joinroom = async (user, room) => {
    try {
      const connection = new HubConnectionBuilder()
        .withUrl(LIVE_URL)
        .configureLogging(LogLevel.Information)
        .build();

      connection.on("UsersInRoom", (users) => {
        setUsers(users);
      });

      connection.on("ReceiveMessage", (user, message) => {
        console.log(message)
        switch (message) {
          case "1": { GetCenterDetails(); break; }
          case "2": { GetPatientWhoNext(); GetPatientInTheCabin(); break; }
          case "5": { ringBell(); break; }
          case "25": {
            ringBellEmergency(); break;
          }
        }
        setMessages(messages => [...messages, { user, message }]);
      });

      connection.onclose(e => {
        setConnection();
        setMessages([]);
        setUsers([]);
      })

      connection.onclose(e => {
        setConnection();
        setMessages([]);
      });

      await connection.start();
      await connection.invoke("JoinRoom", { user, room });
      setConnection(connection);

    } catch (e) {
      console.log(e);
    }
  }

  const sendMessage = async (message) => {
    try {
      await connection.invoke("SendMessage", message);
    } catch (e) {
      console.log(e);
    }
  }

  const closeConnection = async () => {
    try {
      await connection.stop();
    } catch (e) {
      console.log(e);
    }
  }

  ///Chat End Block
  const reConnect = () => {
    joinroom(loginInfo.userName + "_" + centerid + "_Reception", loginInfo.userName + "_" + centerid)
    toast.open("Connected", <VscDebugDisconnect />, "success")
  }
  useEffect(() => {
    joinroom(loginInfo.userName + "_" + centerid + "_Reception", loginInfo.userName + "_" + centerid)
    GetPatientInTheCabin()
    GetPatientWhoNext()
    GetCenterDetails()
  }, [])

  const GetPatientInTheCabin = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetPatientInTheCabin({
      DoctorId: loginInfo.doctorId,
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
      } else {
        setCurrentData()
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setCurrentData()
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const NextPatient = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.NextPatient({
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("2")
        sendMessage("5")
        setIsOpenPop(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenPop(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenPop(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const SetToAbsent = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.SetToAbsent({
      CenterId: centerid,
      Id: currentData.id
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("4")
        sendMessage("5")
        setIsOpenAbsent(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenAbsent(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenAbsent(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const PatientUnavailable = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.PatientUnavailable({
      CenterId: centerid,
      Id: currentData.id
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("3")
        sendMessage("5")
        setIsOpenUnavailable(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenUnavailable(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenUnavailable(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const GetPatientWhoNext = () => {
    setLoding(true)
    start()
    try {
      opdRegisteredCrud.GetPatientWhoNext({
        DoctorId: loginInfo.doctorId,
        CenterId: centerid
      }).then(res => {
        let mdata = res.data
        if (mdata.result.succeeded) {
          setNextPatientData(mdata.data)
        } else {
          setNextPatientData()
        }
        setLoding(false)
        end()
      }).catch(errors => {
        setNextPatientData()
        setLoding(false)
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      })
    }
    catch (error) {
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    }
  }

  const addOpdOffline = (param, setValues) => {
    setLodingCrud(true)
    start()
    opdRegisteredCrud.AddOfline(param).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentSavedData(mdata.data)
        setValues({
          opdCenterId: centerid,
          patientName: "",
          mobile: "",
          bloodGroup: "N/A",
          bloodPressure: "",
          weight: "",
          age: "",
          gender: 0,
          type: 0,
          note: "",
          cityId: "",
          stateId: "",
          patientAddress: ""
        })
        //setIsOpenAdd(false)

        //GetTodaysConfirmed()
        setIsPrint(true)
        toast.open("Opd added successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const GetCenterDetails = () => {
    setLoding(true);
    start()
    GetById(centerid)
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setDoctorStatus(mdata.data.doctorStatus)
          setCenterData(mdata.data);
        } else {
          setCenterData();
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setCenterData();
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }

  const GetDoctorChangeStatus = (s) => {
    setLoding(true)
    start()
    opdCentersCrud.DoctorChangeStatus({
      Status: s,
      Id: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setDoctorStatus(s)
        sendMessage("1")
        toast.open("Doctor is " + GetEDoctorStatusName(s), <FaCircleInfo />, "info")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }
  return (

    <Container>
      <div className="flex flex-col items-center">
        <audio
          ref={audioRef}
          src="/assets/audio/mixkit-cartoon-door-melodic-bell-110.wav"
          preload="auto"
        />
        <audio
          ref={audioEmergencyRef}
          src="/assets/audio/audiomass-output.wav"
          preload="auto"
        />
      </div>

      <div class="flex flex-col w-full ">
        <div class="w-full">
          <Card isBorder={true} isBack={true} title={<div className='w-full flex items-center gap-2'><span><button onClick={reConnect} title='Reconnect' className='btn-success'><PiPlugsConnectedFill /></button></span><span>Reception</span></div>} >
            <div class="justify-end rounded-md md:-mt-10 mt-0 hidden sm:flex" role="group">
              <button type="button" onClick={() => GetDoctorChangeStatus(1)} class={(doctorStatus == 1 ? "bg-green-500" : "bg-gray-400") + " rounded-l-lg px-4 py-2 text-sm font-semibold text-white  border-gray-200 hover:bg-green-400 focus:z-10 focus:ring-2 focus:ring-green-500 active:bg-green-600"}>
                In The Cabin
              </button>
              <button type="button" onClick={() => GetDoctorChangeStatus(4)} class={(doctorStatus == 4 ? "bg-orange-500" : "bg-gray-400") + " px-4 py-2 text-sm font-medium text-white  border-gray-200 hover:bg-orange-400 focus:z-10 focus:ring-2 focus:ring-orange-500 active:bg-orange-600"}>
                On Rest
              </button>
              <button type="button" onClick={() => GetDoctorChangeStatus(0)} class={(doctorStatus == 0 ? "bg-red-500" : "bg-gray-400") + " rounded-r-lg px-4 py-2 text-sm font-semibold text-white  border-gray-200 hover:bg-red-400 focus:z-10 focus:ring-2 focus:ring-red-500 active:bg-red-600"}>
                Offline
              </button>
            </div>
            <div class="text-gray-700">
              <div class="text-center">
                <div class="justify-center flex flex-col items-center">
                  {centerData &&
                    <>
                      <div class="px-4 font-semibold text-2xl">{centerData.centerName}</div>
                      <div class="text-md">{centerData.address}</div>
                      <div class="text-sm">{moment(centerData.opdStartTime).format("LT")} - {moment(centerData.opdEndTime).format("LT")}</div>
                    </>
                  }
                </div>
              </div>
            </div>

            {doctorStatus == 1 &&
              <div class=" flex justify-end rounded-md md:-mt-[35px] mt-0" role="group">
                <button type="button" onClick={() => {
                  setIsOpenPop(!isOpenPop)
                  currentData ?
                    setEventMessages("Are you sure to call Next Patient?") :
                    setEventMessages("Are you sure to Start OPD?")
                }
                } class={`rounded-l-lg ${currentData? "":"rounded-r-lg"} px-6 py-4 text-sm font-semibold text-white bg-green-500 border-gray-200 hover:bg-green-400 focus:z-10 focus:ring-2 focus:ring-green-500 active:bg-green-600`}>
                  {currentData ? "Next" : "Start OPD"}
                </button>
                {currentData &&
                  <>
                    <button type="button" onClick={() => {
                      setIsOpenUnavailable(!isOpenUnavailable)
                      setEventMessages("Are you sure to send current patient in the cabin to unavailable?")
                    }
                    } class=" px-6 py-4 text-sm font-medium text-white bg-orange-500 border-gray-200 hover:bg-orange-400 focus:z-10 focus:ring-2 focus:ring-orange-500 active:bg-orange-600">
                      Unavailable
                    </button>
                    <button type="button" onClick={() => {
                      setIsOpenAbsent(!isOpenAbsent)
                      setEventMessages("Are you sure to send current patient in the cabin to Absent?")
                    }
                    } class="rounded-r-lg px-6 py-4 text-sm font-semibold text-white bg-red-500 border-red-200 hover:bg-red-400 focus:z-10 focus:ring-2 focus:ring-red-500 active:bg-red-600">
                      Absent
                    </button>
                  </>}
              </div>}
          </Card>
        </div>
        <div class="my-2"></div>
        <div class=" flex flex-col md:flex-row" >
          <div class="md:w-9/12 " >
            <Card isBorder={true} >
              <div class="px-2 py-2"></div>
              <div class=" flex w-full" role="group">
                <button type="button" onClick={(e) => setViewUsers(1)} class={(viewUsers == 1 ? "bg-blue-500" : "bg-gray-400") + " rounded-l-lg px-2 sm:px-4 py-2 sm:text-sm font-semibold text-xs text-white  border-gray-200 hover:bg-blue-400 focus:z-10 focus:ring-2 focus:ring-blue-500 active:bg-blue-600"}>
                  Registered
                </button>
                <button type="button" onClick={(e) => setViewUsers(2)} class={(viewUsers == 2 ? "bg-green-500" : "bg-gray-400") + " px-2 sm:px-4 py-2 sm:text-sm font-semibold text-xs text-white  border-gray-200 hover:bg-green-400 focus:z-10 focus:ring-2 focus:ring-green-500 active:bg-green-600"}>
                  Confirmed
                </button>
                <button type="button" onClick={(e) => setViewUsers(3)} class={(viewUsers == 3 ? "bg-red-500" : "bg-gray-400") + " px-2 sm:px-4 py-2 sm:text-sm font-semibold text-xs text-white  border-gray-200 hover:bg-red-400 focus:z-10 focus:ring-2 focus:ring-red-500 active:bg-red-600"}>
                  Emergency
                </button>
                <button type="button" onClick={() => { setIsOpenAdd(!isOpenAdd); setIsPrint(false) }} className="rounded-r-lg sm:rounded-none px-2 sm:px-4 py-2 text-lg sm:text-2xl text-white bg-green-600 focus:z-10 focus:ring-2 focus:ring-green-500 active:bg-green-600">
                  <IoMdAdd />
                </button>
                <div className='hidden sm:block w-full'>
                  <div class="flex items-center w-full">
                    <div class="w-full">
                      <input type="text" value={serachPatient} onChange={(e) => setSerachPatient(e.target.value)} class="outline-none bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-r-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2.5" placeholder={`Search ${viewUsers == 1 ? "registered" : viewUsers == 2 ? "confirmed" : "emergency"} patient...`} required />
                    </div>
                    <button onClick={() => setIsSerachPatient(pre => pre + 1)} class="p-2.5 ms-2 text-sm font-medium text-white bg-brand-500 rounded-lg border border-brand-600 hover:bg-brand-600 focus:ring-4 focus:outline-none focus:ring-brand-600">
                      <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                      </svg>
                      <span class="sr-only">Search</span>
                    </button>
                  </div>
                </div>
              </div>
              {viewUsers == 1 &&
                <ReceptionRegistered isActive={viewUsers == 1} searchTerm={serachPatient} isSearch={isSerachPatient} />
              }
              {viewUsers == 2 &&
                <ReceptionConfirmed isActive={viewUsers == 2} searchTerm={serachPatient} isSearch={isSerachPatient} />
              }
              {viewUsers == 3 &&
                <ReceptionEmergency isActive={viewUsers == 3} searchTerm={serachPatient} isSearch={isSerachPatient} />
              }
            </Card>
          </div>

          <div class="m-2"></div>
          <div class="md:w-3/12" >
            <Card isBorder={true} borderColor="border-green-500">
              {loding ?
                <LoadingContainer text="Please wait..." />
                :
                <div class="text-gray-700">
                  <div class="text-center text-2xl">
                    {currentData ?
                      <>
                        <div class="px-2 py-2 font-semibold"> Current Patient</div>
                        <div class="px-2 py-2 text-3xl">{currentData.patientName}</div>
                        <div>
                          <span className='flex items-center justify-center gap-2'>
                            No.:
                            <span>
                              <span className=" text-4xl font-bold" >{currentData.confirmedAllotedNumber}</span>{currentData.confirmedAllotedNumber != currentData.opdNumberAlloted && <span className='text-sm font-normal'>/{currentData.opdNumberAlloted}</span>}
                            </span>
                            <span>
                              <StatusContainer bg={ETypeBg(currentData.type)} text={GetETypeName(currentData.type)} />
                            </span>
                          </span>
                        </div>
                        <div class="px-2 py-2 text-sm">Ref No. {currentData.id} {currentData.registeredIdForRef && "/" + currentData.registeredIdForRef}</div>
                        <div class="my-2 mx-5"></div>
                      </>
                      :
                      <>
                        <div class="px-2 py-2 font-semibold"> Please Start OPD</div>
                      </>
                    }
                  </div>

                </div>
              }
            </Card>
            {nextPatientData &&
              <>
                <div class="m-4"></div>
                <Card isBorder={true} borderColor="border-brand-500">
                  {loding ?
                    <LoadingContainer text="Please wait..." />
                    :
                    <div class="text-gray-700">
                      <div class="text-center text-2xl">
                        <div class="px-4 py-2 font-bold">Next Patient</div>
                        <div class="px-2 py-2 text-3xl">{nextPatientData.patientName}</div>
                        <div>
                          <span className='flex items-center justify-center gap-2'>
                            No.:
                            <span>
                              <span className=" text-4xl font-bold" >{nextPatientData.confirmedAllotedNumber}</span>{nextPatientData.confirmedAllotedNumber != nextPatientData.opdNumberAlloted && <span className='text-sm font-normal'>/{nextPatientData.opdNumberAlloted}</span>}
                            </span>
                            <span>
                              <StatusContainer bg={ETypeBg(nextPatientData.type)} text={GetETypeName(nextPatientData.type)} />
                            </span>
                          </span>
                        </div>
                        <div class="px-2 py-2 text-sm">Ref No. {nextPatientData.id}{nextPatientData.registeredIdForRef && "/" + nextPatientData.registeredIdForRef}</div>
                        <div class="my-2 mx-5"></div>
                      </div>
                    </div>
                  }
                </Card>
              </>
            }
          </div>
        </div>
      </div>

      <AddOpdOffline addOpdOffline={addOpdOffline} currentSavedData={currentSavedData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} isPrint={isPrint} setIsPrint={setIsPrint} />
      <WarningPopUp call={NextPatient} isOpen={isOpenPop} setIsOpen={setIsOpenPop} loding={lodingCrud} text={eventMessage} />
      <WarningPopUp call={PatientUnavailable} isOpen={isOpenUnavailable} setIsOpen={setIsOpenUnavailable} loding={lodingCrud} text={eventMessage} />
      <WarningPopUp call={SetToAbsent} isOpen={isOpenAbsent} setIsOpen={setIsOpenAbsent} loding={lodingCrud} text={eventMessage} />

    </Container >
  )
}